import { ReactNode, useState } from 'react'
import { twMerge as twm } from 'tailwind-merge'

import { Icon } from '../Icon'
import Card from '../app/design/Card'
import Heading from '../app/design/Heading'

type Props = {
    children?: ReactNode
    title?: string
    isCollapsible?: boolean
    isCollapsed?: boolean
    onChangeIsCollapsed?: (newIsCollapsed: boolean) => void
    className?: string
    defaultIsCollapsed?: boolean
}

export const WorkflowPageCard = ({
    children,
    title,
    defaultIsCollapsed,
    className,
    ...props
}: Props) => {
    const [isCollapsed, setIsCollapsed] = useState(defaultIsCollapsed ?? false)

    const effectiveIsCollapsed = props.isCollapsed ?? isCollapsed
    const effectiveSetIsCollapsed = props.onChangeIsCollapsed ?? setIsCollapsed

    const canCollapse =
        props.isCollapsed !== undefined || props.isCollapsible || defaultIsCollapsed !== undefined

    return (
        <Card
            size="lg"
            className={twm(
                'flex flex-col items-stretch justify-start gap-y-8',
                isCollapsed && 'cursor-pointer',
                className
            )}
            onClick={isCollapsed ? () => effectiveSetIsCollapsed(false) : undefined}
        >
            {(title !== undefined || canCollapse) && (
                <div
                    className={twm(
                        'flex items-center',
                        title !== undefined && canCollapse
                            ? 'justify-between'
                            : title !== undefined
                              ? 'justify-start'
                              : 'justify-end',
                        canCollapse && 'cursor-pointer'
                    )}
                    onClick={
                        canCollapse
                            ? () => effectiveSetIsCollapsed(!effectiveIsCollapsed)
                            : undefined
                    }
                >
                    {title !== undefined && <Heading size="sm">{title}</Heading>}

                    {canCollapse && (
                        <Icon
                            icon={effectiveIsCollapsed ? 'chevronDown.large' : 'chevronUp.large'}
                        />
                    )}
                </div>
            )}

            {!effectiveIsCollapsed && children}
        </Card>
    )
}
